import * as React from 'react';
import { IListItem } from '@nkr/models/index';
import { Col, ControlLabel, Form, FormControl, FormGroup, Panel, Row } from 'react-bootstrap';
import { TableWrapper } from '../styles';

interface IProps {
    requiredTubeList: IListItem[],
    transLavender85: number,
    transLavender40: number,
    transLavender70: number,
    transLavender100: number,
    transPink60: number,
    transPink100: number,
    transRed70: number,
    transRed100: number,
    transGreen100: number,
    transYellow85: number,
    onChange: (e: React.FormEvent<FormControl & HTMLSelectElement>) => void
}

const TransportTubes = (props: IProps) => {
    const {
        transLavender85, transLavender40, transLavender70, transLavender100,
        transPink60, transPink100, transRed70, transRed100,
        transGreen100, transYellow85
    } = props;

    const tubeMap = [
        {
            color: 'Lavender', tubes: [
                { size: '3.0 ml [367856]', property: 'transLavender85' },
                { size: '4.0 ml [367861]', property: 'transLavender40' },
                { size: '7.0 ml [367863]', property: 'transLavender70' },
                { size: '10.0 ml [366643]', property: 'transLavender100' },
            ]
        },
        {
            color: 'Pink', tubes: [
                { size: '6.0 ml [367899]', property: 'transPink60' },
                { size: '10.0 ml [366643]', property: 'transPink100' },
            ]
        },
        {
            color: 'Red', tubes: [
                { size: '7.0 ml [367815]', property: 'transRed70' },
                { size: '10.0 ml [367820]', property: 'transRed100' },
            ]
        },
        {
            color: 'Green', tubes: [
                { size: '10.0 ml [367874]', property: 'transGreen100' },
            ]
        },
        {
            color: 'Yellow', tubes: [
                { size: '8.5 ml [364606]', property: 'transYellow85' },
            ]
        }
    ]

    return (
        <Panel style={{ marginBottom: 0 }}>
            <Panel.Heading>
                Tubes for Transport (Please indicate the tubes your center requires the donor center to pack with the kidney at the time of transport)
            </Panel.Heading>
            <Panel.Body>
                <TableWrapper condensed>
                    <tbody>
                        {tubeMap.map(item =>
                            <tr>
                                <td><strong>{item.color}:</strong></td>
                                {item.tubes.map(t =>
                                    <>
                                        <td>{t.size}</td>
                                        <td>
                                            <FormControl
                                                componentClass='select'
                                                id={t.property}
                                                value={eval(t.property)}
                                                onChange={props.onChange}
                                            >
                                                {props.requiredTubeList.map(tube =>
                                                    <option value={tube.id}>{tube.description}</option>
                                                )}
                                            </FormControl>
                                        </td>
                                    </>
                                )}
                            </tr>
                        )}
                    </tbody>
                </TableWrapper>
            </Panel.Body>
        </Panel>
    );
}

export default TransportTubes;